import React from 'react';
import Link from 'gatsby-link';
import axios from'axios';
import './_info.scss';

export default class InfoBox extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            info: null
        }
    }

    componentDidMount() {
        axios.get('/query.php').then((response) => {
            let key = undefined;
            for(key in response.data) {
                if(response.data[key][0] == this.props.name) {
                    this.setState({
                        info: response.data[key][1]
                    });
                }
            }
        }).catch((error) => {
            this.setState({
                info: null
            });
        });
    }

    render() {
        let {children} = this.props;
        return this.state.info != null ? (
            <div className="info-box">
                <h2 className="large dark">
                    Wartezeit
                </h2>
                <p>{ this.state.info }</p>
            </div>
        ) : null
    }
}


// WEBPACK FOOTER //
// ./src/components/navigation/infobox/index.jsx